export const isValidUrl = (url: string): boolean => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    new URL(url);
    return true;
  } catch (_) {
    return false;
  }
};

export const isExternalUrl = (url: string): boolean => {
  return url.startsWith('http://') || url.startsWith('https://');
};
